<template>
  <div class="member-address-tab">
    <BaseTable v-loading="loading" :data="tableData">
      <EmptyBlock slot="empty" />
      <BaseElTableColumn prop="address" :label="$t('member.tab.memberAddress.address')" align="center" />
      <BaseElTableColumn prop="isDefault" :label="$t('member.tab.memberAddress.isDefault')" align="center">
        <template slot-scope="scope">
          <Tag :type="tagType(scope.row.isDefault)">{{ scope.row.isDefault ? $t('member.tab.memberAddress.yes') : $t('member.tab.memberAddress.no') }}</Tag>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="createdAt" :label="$t('member.tab.memberAddress.createdAt')" align="center">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="updatedAt" :label="$t('member.tab.memberAddress.updatedAt')" align="center">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updatedAt) }}
        </template>
      </BaseElTableColumn>
    </BaseTable>
  </div>
</template>

<script>
import tableMixin from '@/mixin/table'
import { GetUserMoreInfoAddress } from '@/api/member'
import dayjs from '@/lib/dayjs'
export default {
  name: 'MemberAddressTab',
  mixins: [tableMixin],
  props: {
    memberId: String,
  },
  data: () => ({
    tableData: [],
  }),
  async mounted () {
    this.getMemberAddress()
  },
  methods: {
    tagType (isDefault) {
      if (isDefault) return 'action'
      return 'info'
    },
    async getMemberAddress () {
      this.loading = true
      const [res, err] = await GetUserMoreInfoAddress({
        shopId: this.shop,
        memberId: this.memberId,
      })
      this.loading = false
      if (err) return this.$message.error(err)
      this.tableData = res.sort((a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf())
    },
  },
}
</script>

<style lang="postcss" scoped>

</style>
